export default __webpack_public_path__ + "static/media/la_capelle19.4a366478.jpg";